"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../../store/crude/crude.selector");
var material_1 = require("@mui/material");
var DialogComponent_1 = __importDefault(require("../../../../shared/components/MessageComponents/DialogComponent"));
var CrudeCreateTextFieldDialog = function (props) {
    var _a, _b;
    var t = react_i18next_1.useTranslation().t;
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var _c = react_1.default.useState(props.open), openDialog = _c[0], setOpenDialog = _c[1];
    var _d = react_1.default.useState(''), name = _d[0], setName = _d[1];
    var _e = react_1.default.useState(''), value = _e[0], setValue = _e[1];
    var _f = react_1.default.useState(''), errorText = _f[0], setErrorText = _f[1];
    var _g = react_1.default.useState(false), showError = _g[0], setShowError = _g[1];
    react_1.useEffect(function () {
        setOpenDialog(props.open);
    }, [props.open]);
    react_1.useEffect(function () {
        setErrorText('');
        setShowError(false);
    }, [name, value]);
    var closeDialog = function () {
        setErrorText('');
        setShowError(false);
        setName('');
        setValue('');
        setOpenDialog(false);
        props.openDialog(false);
    };
    var saveTextField = function () {
        if (!name) {
            setErrorText(t('crude:insertTextFieldLabel'));
            setShowError(true);
        }
        else {
            var json = props.json || {};
            json[name] = value;
            props.onChangeJson(json);
            closeDialog();
        }
    };
    return (react_1.default.createElement(DialogComponent_1.default, { open: openDialog, request: true, title: t('crude:createOwnTextField'), onClose: function () { return closeDialog(); }, cancelLabel: t('crude:cancel'), confirmLabel: t('crude:save'), autoClose: false, onCancel: function () { return closeDialog(); }, onConfirm: saveTextField, content: 
        // <form noValidate>
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.TextField, { error: showError, helperText: errorText, fullWidth: true, id: 'name', name: 'name', label: t('crude:textFieldName'), onChange: function (event) { setName(event.target.value); }, value: name, margin: 'normal', variant: (_a = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _a === void 0 ? void 0 : _a.type }),
            react_1.default.createElement(material_1.TextField, { id: 'value', name: 'value', variant: (_b = appLayout === null || appLayout === void 0 ? void 0 : appLayout.textfield) === null || _b === void 0 ? void 0 : _b.type, label: t('crude:textFieldValue'), fullWidth: true, onChange: function (event) { setValue(event.target.value); }, value: value, margin: 'normal' })) }));
};
exports.default = CrudeCreateTextFieldDialog;
